import BalanceDisplay from './balance-display';

import FungibleTokens from 'services/fungible-tokens';
const { getFormattedTokenAmount } = FungibleTokens;

import {
  StyledContainer,
  StyledNearAmount,
  StyledFiatAmount,
  StyledDots
} from './balance.style';

type BalanceProps = {
  amount: string;
  symbol: string;
  showBalanceInNEAR?: boolean;
  showBalanceInUSD?: boolean;
  nearTokenFiatValueUSD?: string | undefined;
};

const Balance = ({
  amount,
  symbol,
  showBalanceInNEAR = true,
  showBalanceInUSD = true,
  nearTokenFiatValueUSD
}: BalanceProps) => {
  return (
    <StyledContainer>
      {showBalanceInNEAR && (
        <>
          {amount ? (
            <StyledNearAmount>
              {getFormattedTokenAmount(amount, symbol, 24)}
            </StyledNearAmount>
          ) : (
            <StyledDots>Loading</StyledDots>
          )}
        </>
      )}
      {showBalanceInUSD && (
        <StyledFiatAmount>
          <BalanceDisplay
            amount={amount}
            nearTokenFiatValueUSD={nearTokenFiatValueUSD}
          />
        </StyledFiatAmount>
      )}
    </StyledContainer>
  );
};

export default Balance;
